export default function reduce(state = null): null {
	return state
}
